import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  ContentProvider,
  PageContainer,
  PageHeader,
  PageLead,
} from '../content/components';
import { ContentSection } from '../layout/components';

import { CrossLinksSection, CrossLinkBlock } from './components';

import {
  BleedSectionSplitLeft,
  BleedSectionLandscapeRight,
} from './components/sections';

class NewsEventsPage extends Component {
  static propTypes = {
    breakpoint: PropTypes.string.isRequired,
  };

  render() {
    const { breakpoint } = this.props;

    return (
      <ContentProvider
        slug="news-events"
        render={({
          header,
          intro,
          article,
          event,
          events,
          news,
          cross_links,
        }) => (
          <PageContainer>
            <PageHeader mainImage={header.main_image} />
            <PageLead
              title={header.title}
              subtitle={header.subtitle}
              content={intro.content}
              links={intro.links}
              supportImage={
                header.support_media_format === 'circular'
                  ? header.support_image_circular
                  : header.support_image_portrait
              }
              supportVideo={header.support_video}
              supportMediaType={header.support_media_type}
              supportIsCircular={header.support_media_format === 'circular'}
            />
			  {/* Exlcude two hero article slots
            <BleedSectionSplitLeft
              breakpoint={breakpoint}
              subTitle={article.subtitle}
              title={article.title}
              mainImage={article.main_image}
              supportImage={article.square_image}
              overlayImage={article.support_image}
              renderContent={() => (
                <div dangerouslySetInnerHTML={{ __html: article.content }} />
              )}
              links={article.links}
            />

            <BleedSectionLandscapeRight
              breakpoint={breakpoint}
              subTitle={event.subtitle}
              title={event.title}
              mainImage={event.main_image}
              supportImage={event.support_image}
              supportVideo={event.support_video}
              supportMediaType={event.support_media_type}
              renderContent={() => (
                <div dangerouslySetInnerHTML={{ __html: event.content }} />
              )}
              links={event.links}
            />
			  */}
            {events && (
              <ContentSection noMargin>
                {events.map((event, index) => (
                  <CrossLinkBlock
                    key={index}
                    image={event.image}
                    linkTarget={event.link.url}
                    linkLabel={event.link.title}
                    category={event.category}
                  >
                    <h2>{event.title}</h2>
                    <p dangerouslySetInnerHTML={{ __html: event.body }} />
                  </CrossLinkBlock>
                ))}
              </ContentSection>
            )}
			{/** Exlcude more from us links 
            {news && (
              <ContentSection title="More from us" noMargin>
                {news.map((item, index) => {
                  const categoryString =
                    item.category + (item.date && ` - ${item.date}`);
                  return (
                    <CrossLinkBlock
                      key={index}
                      category={categoryString}
                      linkLabel={item.link.title}
                      linkTarget={item.link.url}
                    >
                      <h2>{item.title}</h2>
                    </CrossLinkBlock>
                  );
                })}
              </ContentSection>
            )}
			**/}
            {cross_links && <CrossLinksSection crossLinks={cross_links} />}
          </PageContainer>
        )}
      />
    );
  }
}

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(NewsEventsPage);



// WEBPACK FOOTER //
// ./src/modules/pages/NewsEventsPage.js